import script from "./CTournamentHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTournamentHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CTournamentHeader.vue?vue&type=style&index=0&id=b637bb68&lang=less"

const __exports__ = script;

export default __exports__